import axios from "axios";
import React, { useState, useEffect } from "react";
import { UserConsumer } from "../../../UserContext";
import Header from "../../../components/Header";
import SpSelectCriteriaFilterationBar from "../../../components/SpSelectCriteriaFilterationBar";
import SelectCriteriaForm from "./SelectCriteriaForm";
import TablewithPagination from "../../../components/TablewithPagination";
import { MonthlyTimesheet_API } from "./MonthlyTimesheet_API";
import { Button, Input } from "reactstrap";
import { AlertPopups } from "../../../components/AlertPopups";
import { Redirect } from "react-router-dom";
import ButtonLoader from "../../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
	SendEmailBtnTitle,
	SendEmailClassName,
} from "../../ticketModule/variables/ListingVariables";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function MonthlyTimesheet() {
	let token,
		joiningDate,
		empId = null;

	const [errorInRows, setErrorInRows] = useState([]);
	const [selectedRows, setSelectedRows] = useState([]);
	const [showBtnLoading, setShowBtnLoading] = useState(false);
	const [checkboxChecked, setcheckboxChecked] = useState({
		sheetId: null,
		value: null,
	});

	const [sortBy, setSortBy] = useState({
		dataField: "empName",
		order: "asc",
	});

	const tableHeaders = [
		{
			name: "checkbox",
			displayName: "checkbox",
			sort: false,
			formatter: (cell, row) => {
				return (
					<span>
						<Input
							type="checkbox"
							style={{ marginLeft: 90 }}
							checked={cell}
						/>
					</span>
				);
			},
		},
		{
			name: "empName",
			displayName: "Employee Name",
			sort: true,
		},
		{
			name: "recordMonth",
			displayName: "Month",
			sort: true,
		},
		{
			name: "calculatedDays",
			displayName: "Calculated Days",
			sort: true,
		},
		{
			name: "hoursWorked",
			displayName: "Hours Worked",
			sort: true,
		},
		{
			name: "hoursExpected",
			displayName: "Hours Expected",
			sort: true,
		},
		{
			name: "noOfLateComings",
			displayName: "No. of Late Coming",
			sort: true,
		},
		{
			name: "hoursDifference",
			displayName: "Hours Differences",
			sort: true,
		},
		{
			name: "systemCalculatedDeduction",
			displayName: "System Calculated Deduction",
			sort: true,
		},
		{
			name: "supSuggestedDeduction",
			displayName: "Supervisor Suggested Deduction",
			sort: true,
		},
		{
			name: "supComments",
			displayName: "Supervisor Comments for Deduction & Late Comings",
			sort: false,
		},
		{
			name: "supStatus",
			displayName: "Supervisor Status",
			sort: true,
		},
		{
			name: "adminApproved",
			displayName: "Admin Suggested Deduction",
			sort: true,
		},
		{
			name: "adminStatus",
			displayName: "Admin Status",
			sort: true,
		},
	];
	let months = [
		{ value: 0, label: "All" },
		{ value: 1, label: "January" },
		{ value: 2, label: "February" },
		{ value: 3, label: "March" },
		{ value: 4, label: "April" },
		{ value: 5, label: "May" },
		{ value: 6, label: "June" },
		{ value: 7, label: "July" },
		{ value: 8, label: "August" },
		{ value: 9, label: "September" },
		{ value: 10, label: "October" },
		{ value: 11, label: "November" },
		{ value: 12, label: "December" },
	];
let employeeId,
		empDepartment,
		empDesignation = null;
	let date = new Date();
	let currentMonth = months[date.getMonth()];
	let currentYear = date.getFullYear();
	const [employeeList, setEmployeeList] = useState([]);
	const [selectedEmployee, setSelectedEmployee] = useState(null);
	const history = useHistory();
	const [pageNum, setPageNum] = useState(1);
	const [isLoaded, setIsLoaded] = useState(false);
	const [order, setOrder] = useState("asc");
	const [supSuggestedDeduction, setSupSuggestedDeduction] = useState(null);
	const [supSuggestedComments, setSupSuggestedComments] = useState("");
	const [monthlyTimesheetResults, setMonthlyTimesheetData] = useState([]);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [selectedMonth, setSelectedMonth] = useState(currentMonth);
	const [yearsList, setYearsList] = useState([]);
	const [selectedYear, setSelectedYear] = useState({
		value: currentYear,
		label: currentYear,
	});

	useEffect(() => {
			let UrlParams = new URLSearchParams(window.location.search);
		const empId = UrlParams.get("emp");

		if (empId) {
			let empName = history.location.state?.empName;
		getEmployeeList(empId, empName);
		}
		else{
			getEmployeeList();
		}
		//To auto start from joining date till current year
		
		const list = [];
		do {
			list.unshift({ value: joiningDate, label: joiningDate.toString() });
			joiningDate++;
		} while (joiningDate != currentYear + 1);
		setYearsList(list);

		const header = {
			Authorization: `Bearer ${token}`,
		};

		axios
			.get(
				`${MonthlyTimesheet_API.GetMonthlyTimesheetList}Month=${selectedMonth.value}&Year=${selectedYear.value}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: header,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					if (data.monthlyTimesheetResults.length) {
						setIsLoaded(true);
					}
					setIsLoaded(true);
					const resData = data.monthlyTimesheetResults;
					setMonthlyTimesheetData(resData);

					let supDed = [];
					for (let element of resData) {
						supDed.push(element.supSuggestedDeduction);
					}
					setSupSuggestedDeduction(supDed);
				}
			});
		setApiHeaderToken(header);
	}, []);
const getEmployeeList = (empId, empName) => {
		if (
			empDepartment === "5" || //Accounts
			empDepartment === "9" || //Admin
			empDesignation?.toString() === "4" || //CM
			employeeId?.toString() === "180" || //Abdullah
			employeeId?.toString() === "42" || //Umer khan
			employeeId?.toString() == "232" /*Moazzam*/
		) {
			axios
				.get(`${MonthlyTimesheet_API.GetEmployeeList}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					let list = empList.map((item) => {
						return { value: item.employeeId, label: item.name };
					});
					let allEmp = { value: 0, label: "All" };
					list.unshift(allEmp);
					if (empId)
						setSelectedEmployee({ value: empId, label: empName });
					else setSelectedEmployee(allEmp);
					setEmployeeList(list);
				});
		} else {
			axios
				.get(
					`${MonthlyTimesheet_API.GetSupervisorsEmployeesList}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then(({ data }) => {
					const empList = data;
					empList.sort((a, b) => a.name.localeCompare(b.name));
					let list = empList.map((item) => {
						return { value: item.employeeId, label: item.name };
					});
					let allEmp = { value: 0, label: "All" };
					list.unshift(allEmp);
					setSelectedEmployee(allEmp);
					setEmployeeList(list);
				});
		}
		setApiHeaderToken({ Authorization: `Bearer ${token}` });
	};
	const onHeaderCheckboxChange = (isChecked) => {
		setErrorInRows(null);
		let sugDeduction = [...supSuggestedDeduction];
		for (let i = 0; i < selectedRows?.length; i++) {
			sugDeduction[selectedRows[i]] =
				monthlyTimesheetResults[selectedRows[i]].supSuggestedDeduction;
		}
		setSupSuggestedDeduction(sugDeduction);

		let allRows = monthlyTimesheetResults.map((obj, index) => {
			return index;
		});

		if (isChecked) {
			setSelectedRows(allRows);
		} else {
			setSelectedRows([]);
		}
	};
	const onTableCheckboxChange = (index) => {
		setErrorInRows(null);
		let sugDeduction = [...supSuggestedDeduction];

		for (let i = 0; i < selectedRows?.length; i++) {
			sugDeduction[selectedRows[i]] =
				monthlyTimesheetResults[selectedRows[i]].supSuggestedDeduction;
		}
		setSupSuggestedDeduction(sugDeduction);

		const doesExists = selectedRows?.find((id) => id === index);

		if (doesExists) {
			const filtered = selectedRows.filter((id) => id != index);
			setSelectedRows(filtered);
		} else {
			try {
				setSelectedRows((current) =>
					current ? [...current, index] : [index]
				);
			} catch (error) {}
		}
	};
	const updateTableData = (month, year,empId) => {
		setIsLoaded(false);
		axios
			.get(
				`${MonthlyTimesheet_API.GetMonthlyTimesheetList}&Month=${month}&Year=${year}&EmployeeId=${
						empId}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					if (data.monthlyTimesheetResults.length) {
						setIsLoaded(true);
					}
					debugger
					setIsLoaded(true);

					const resData = data.monthlyTimesheetResults;
					setMonthlyTimesheetData(resData);

					let supDed = [];
					for (let element of resData) {
						supDed.push(element.supSuggestedDeduction);
					}
					setSupSuggestedDeduction(supDed);
				}
			});
	};

	const exportToExcel = () => {
		setShowBtnLoading(true);
		axios({
			url: `${MonthlyTimesheet_API.ExportToExcel}?Month=${selectedMonth.value}&year=${selectedYear.value}`,
			method: "GET",
			responseType: "blob",
			headers: apiHeaderToken,
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "monthlyTimesheet.xlsx");
				document.body.appendChild(link);
				link.click();
				setShowBtnLoading(false);
			})
			.catch(() => {
				setShowBtnLoading(false);
			});
	};
	const SendMonthlyTimesheetEmail = () => {
		
		setIsLoaded(false);
		axios
			.post(
				`${MonthlyTimesheet_API.SendMonthlyTimesheetEmail}Month=${selectedMonth.value}&Year=${selectedYear.value}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					axios
					.get(
						`${MonthlyTimesheet_API.GetMonthlyTimesheetList}Month=${selectedMonth.value}&Year=${selectedYear.value}&SortBy=${sortBy.dataField}_${sortBy.order}`,
						{
							headers: apiHeaderToken,
						}
					)
					.then(({ status, data }) => {
						if (status === 200) {
							if (data.monthlyTimesheetResults.length) {
								setIsLoaded(true);
							}
							setIsLoaded(true);
							const resData = data.monthlyTimesheetResults;
							setMonthlyTimesheetData(resData);
							let sheetStates = [];
							for (let element of resData) {
								const id = element.sheetId;
								sheetStates.push({
									sheetId: id,
									isChecked: false,
								});
							}
							setcheckboxChecked(sheetStates);
						}
					});
				}
			});
	};
	const handleSubmit = async () => {
		let data = [];
		let row = [];
		let dataAtIndex = [];

		for (let i = 0; i < supSuggestedDeduction.length; i++) {
			if (supSuggestedDeduction[i] === "") {
				if (errorInRows) setErrorInRows([...errorInRows, i]);
				else setErrorInRows([i]);
			}
		}

		let hasError = false;
		for (let element of supSuggestedDeduction) {
			if (element === "") {
				hasError = true;
			}
		}
		if (hasError) {
			return;
		} else {
			for (let element of selectedRows) {
				row = monthlyTimesheetResults.find(
					(item, index) => index == element
				);
				row.supSuggestedDeduction = supSuggestedDeduction[element];
				data.push(row);
			}

			for (let element of data) {
				let update = supSuggestedDeduction.includes(dataAtIndex);
				if (update)
					element.supSuggestedDeduction =
						supSuggestedDeduction[dataAtIndex];
			}
			const formFields = {
				updateMonthlyTimesheetsDto: data,
			};

			let response = await axios
				.post(
					`${MonthlyTimesheet_API.PostMonthlyTimesheetList}`,
					formFields,
					{
						headers: apiHeaderToken,
					}
				)
				.then(({ status }) => {
					if (status === 200) {
						AlertPopups.successAlert.fire({
							text: "Updated",
						});
						return status;
					} else if (status === 400) {
						AlertPopups.ErrorAlert.fire({
							text: "Monthly Timesheet Updation Error",
						});
					}
				})
				.catch((error) => {
					if (error.response)
						AlertPopups.ErrorAlert.fire({
							text: error.response.data.message,
						});
				});
			if (response === 200) {
				setSelectedRows(null);

				axios
					.get(
						`${MonthlyTimesheet_API.GetMonthlyTimesheetList}Month=${selectedMonth.value}&Year=${selectedYear.value}&SortBy=${sortBy.dataField}_${sortBy.order}`,
						{
							headers: apiHeaderToken,
						}
					)
					.then(({ status, data }) => {
						if (status === 200) {
							if (data.monthlyTimesheetResults.length) {
								setIsLoaded(true);
							}
							setIsLoaded(true);
							const resData = data.monthlyTimesheetResults;
							setMonthlyTimesheetData(resData);
							let sheetStates = [];
							for (let element of resData) {
								const id = element.sheetId;
								sheetStates.push({
									sheetId: id,
									isChecked: false,
								});
							}
							setcheckboxChecked(sheetStates);
						}
					});
			}
		}
	};

	const sortByColumn = (name) => {
		setIsLoaded(false);
		if (order === "asc") {
			sort(name, order);
			setOrder("desc");
		} else {
			sort(name, order);
			setOrder("asc");
		}
	};

	const sort = (name, order) => {
		setSortBy({
			dataField: name,
			order: order,
		});
		setIsLoaded(false);
		axios
			.get(
				`${MonthlyTimesheet_API.GetMonthlyTimesheetList}Month=${selectedMonth.value}&Year=${selectedYear.value}&SortBy=${name}_${order}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					if (data.monthlyTimesheetResults.length) {
						setIsLoaded(true);
					}
					setIsLoaded(true);

					setPageNum(1);
					const resData = data.monthlyTimesheetResults;
					setMonthlyTimesheetData(resData);
					let sheetStates = [];
					for (let element of resData) {
						const id = element.sheetId;

						sheetStates.push({ sheetId: id, isChecked: false });
					}
					setcheckboxChecked(sheetStates);
				}
			});
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
					empDesignation = userDetails.designation;
				empDepartment = userDetails.department;
				employeeId = userDetails.id;
				empId = userDetails.id;
				joiningDate = userDetails.empJoinedOn.split("-")[0];
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<>
						<div>
							<Header
								title="Monthly Timesheets"
								headerBorder={true}
							/>
							<SpSelectCriteriaFilterationBar>
								<SelectCriteriaForm
								employeeList={employeeList}
								selectedEmployee={selectedEmployee}
								onEmployeeChange={(value) =>{
						setSelectedEmployee(value)
						updateTableData(
											selectedMonth.value,
											selectedYear.value,
											value.value,
										);
								}
									
									
								}
									months={months}
									selectedMonth={selectedMonth}
									onMonthChange={(value) => {
										setSelectedMonth(value);
										updateTableData(
											value.value,
											selectedYear.value,
											selectedEmployee.value
										);
									}}
									years={yearsList}
									selectedYear={selectedYear}
									onYearChange={(value) => {
										setSelectedYear(value);
										updateTableData(
											selectedMonth.value,
											value.value,
											selectedEmployee.value
										);
									}}
								/>
							</SpSelectCriteriaFilterationBar>
							<div className="float-right my-3">
							{empId === "33" && ( // Check if empId is 33
        <ButtonLoader
            className={SendEmailClassName}
            onClick={SendMonthlyTimesheetEmail}
            disabled={
                !monthlyTimesheetResults.length ||
                showBtnLoading
            }
            btnTitle={SendEmailBtnTitle}
            showBtnLoading={showBtnLoading}
        />
    )}
							</div>
							<div className="float-right my-3  mr-3">
								<ButtonLoader
									className={ExcelBtnClassName}
									onClick={exportToExcel}
									disabled={
										!monthlyTimesheetResults.length ||
										showBtnLoading
									}
									btnTitle={ExcelBtnTitle}
									showBtnLoading={showBtnLoading}
								/>
							</div>
							<TablewithPagination
								empId={empId}
								tableHeader={tableHeaders}
								errorInRows={errorInRows}
								dataLength={monthlyTimesheetResults.length}
								spMontlyTimesheet={monthlyTimesheetResults}
								paginationPage={pageNum}
								IsLoaded={isLoaded}
								defaultSorted={sortBy}
								sortBy={(name) => sortByColumn(name)}
								selectedRows={selectedRows}
								onHeaderCheckboxChange={onHeaderCheckboxChange}
								checkboxCheckedStates={checkboxChecked}
								checkboxChecked={checkboxChecked}
								onCheckboxChange={(index) => {
									onTableCheckboxChange(index);
								}}
								supSuggestedDeduction={supSuggestedDeduction}
								onSupSuggestedChange={(value, index) => {
									let sugDeduction = [
										...supSuggestedDeduction,
									];
									sugDeduction[index] = value;
									setSupSuggestedDeduction(sugDeduction);
									if (
										errorInRows?.includes(index) ||
										value === ""
									) {
										const removedIndex =
											errorInRows?.filter(
												(item) => item != index
											);
										setErrorInRows(removedIndex);
									}
								}}
								handleSubmit={() => handleSubmit()}
								supSuggestedComments={supSuggestedComments}
								onSupCommentsChange={(sheetId, value) => {
									const row = monthlyTimesheetResults.find(
										(item) => item.sheetId === sheetId
									);
									row.supComments = value;
									setSupSuggestedComments(value);
								}}
							/>
							<div className="d-flex justify-content-end my-2 mt-3">
								<Button
									type="submit"
									className="submit-btn"
									onClick={handleSubmit}
									disabled={!monthlyTimesheetResults.length}
								>
									Update
								</Button>
							</div>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default MonthlyTimesheet;
